import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/image/logo.png'
import _imports_1 from '../assets/image/bar.png'


const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  key: 0,
  class: "logo-container"
}
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "logo d-flex justify-content-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "logo-img",
  src: _imports_0
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"height":"42px"}
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "fs-4 page-header-title logo-text" }, "BERJAYA FINANCE - RPK", -1)
const _hoisted_9 = {
  key: 0,
  class: "fs-4 page-header-title logo-text text-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.isLoginPortal && !_ctx.isForgotPasswordPortal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_router_link, {
                  to: "/home",
                  title: "Home"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6,
                    _hoisted_7
                  ]),
                  _: 1
                }),
                _hoisted_8,
                (_ctx.envMode != null && _ctx.envMode != '')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, " [" + _toDisplayString(_ctx.envMode) + "]", 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}